import { render, staticRenderFns } from "./FrenosUnicos.vue?vue&type=template&id=b3b1a214&"
import script from "./FrenosUnicos.vue?vue&type=script&lang=js&"
export * from "./FrenosUnicos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports